import Proptypes from 'prop-types'
import Video from 'components/Video'
import { isPartVisible } from 'utils/displayByDateAndTime'
import { useOnlineStatus } from '../../../hooks/useOnlineStatus'
import PwaOfflinePlaceholder from 'components/PwaOfflinePlaceholder'

export const PartVideo = ({ part }) => {
  const online = useOnlineStatus()
  if (!online) {
    return <PwaOfflinePlaceholder />
  }

  if (!isPartVisible(part)) return null

  switch (part.type) {
    case 'VideoYoutube':
    case 'Video':
    case 'Vimeo':
      return (
        <Video
          url={part.url}
          type={part.type}
          title={part.title}
          legend={part.legend}
          legendSize={part.legendSize}
          style={part.style}
          timeStart={part.timeStart}
        />
      )
    default:
      return null
  }
}

PartVideo.propTypes = {
  part: Proptypes.object,
}

export default PartVideo
